// extracted by mini-css-extract-plugin
module.exports = {"wrap":"research_wrap__Ze_p6","img":"research_img__BHADs","input-container":"research_input-container__tzCc8"};